import {
  createCustomerDependentPagedAutoCompleteMetaData,
  createDomainPagedAutoCompleteMetaData,
} from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { numberNanable } from "commons/ultilities/validation";
import { cloneDeep } from "lodash";
import {
  IAddWorkOrder,
  IUpdateWorkOrder,
} from "mobx-stores/_models/work-order/work-order";

import { date, number, string } from "yup";
export const getAddWorkOrderFormSchema = (
  form: IForm,
): ObjectSchemaType<IAddWorkOrder> => {
  const resolveCustomerId = () => form?.getControl("customerId").value ?? null;

  return {
    date: {
      gridSize: 6,
      label: "Ngày",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },
    woNumber: {
      gridSize: 6,
      label: "Số phiếu",
      type: InputType.text,
      validattionYupSchema: string().required().max(50),
    },

    customerId: {
      type: InputType.autoComplete,
      gridSize: 12,
      label: "Tên giao dịch",
      validattionYupSchema: string().required(),
      metaData: createDomainPagedAutoCompleteMetaData("customer"),
    },
    note: {
      gridSize: 12,
      label: "Ghi chú",
      type: InputType.textArea,
      validattionYupSchema: string().max(512),
    },
    items: {
      label: "Thông tin mặt hàng",
      type: InputType.array,
      arraySchema: {
        productId: {
          label: "Mặt hàng",
          gridSize: 12,
          type: InputType.autoComplete,
          validattionYupSchema: string().required(),
          metaData: createCustomerDependentPagedAutoCompleteMetaData(
            "product",
            resolveCustomerId,
          ),
          defaultValue: "",
        },
        amount: {
          label: "Số lượng",
          gridSize: 3,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        productionAmount: {
          label: "SL sản xuất",
          gridSize: 3,
          type: InputType.number,
          validattionYupSchema: numberNanable(),
          defaultValue: 0,
        },
        finishedAmount: {
          label: "SL thành phẩm",
          gridSize: 3,
          type: InputType.number,
          validattionYupSchema: numberNanable(),
          defaultValue: 0,
        },
        wastageAmount: {
          label: "SL hao hụt",
          gridSize: 3,
          type: InputType.number,
          validattionYupSchema: numberNanable(),
          defaultValue: 0,
        },
        note: {
          label: "Ghi chú",
          gridSize: 12,
          type: InputType.text,
          validattionYupSchema: string().max(512),
          defaultValue: "",
        },
      },
    },
  };
};

export const getEditWorkOrderFormSchema = (
  form: IForm,
): ObjectSchemaType<IUpdateWorkOrder> => {
  const schema = getAddWorkOrderFormSchema(form);
  const updateSchema: ObjectSchemaType<IUpdateWorkOrder> = cloneDeep(schema);
  updateSchema.id = {
    type: InputType.none,
  };
  updateSchema.items.arraySchema.id = {
    type: InputType.none,
  };
  return updateSchema;
};
